<template>
  <div>
    <listing-loader
      page="tagged"
      :tagged="name"
    />
  </div>
</template>

<script>
import ListingLoader from '@/components/ListingLoader.vue';

export default {
  name: 'Tagged',
  components: {
    ListingLoader,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  watch: {
    name() {},
  },
};
</script>
